/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="smile" size=32 />
 */
const Smile = () => (
	<path
		fillRule="evenodd"
		clipRule="evenodd"
		d="M26.7247 12.3264L29.9383 12.8283L30.0617 12.0379L24.2156 11.1248L24.0921 11.9152L25.9324 12.2026C25.2921 14.9823 22.3997 20.2991 15.6956 20.2991C9.37147 20.2991 6.43919 15.5677 5.58967 12.6982L8.26766 11.9035L8.04008 11.1366L1.88623 12.9626L2.11381 13.7296L4.82336 12.9256C5.73905 16.0014 8.88534 21.0991 15.6956 21.0991C22.9707 21.0991 26.0646 15.2819 26.7247 12.3264Z"
		fill="#002855"
	/>
);

export default Smile;
